// extracted by mini-css-extract-plugin
export default {"container":"ProgressBar_container__FN5+w","bar":"ProgressBar_bar__XSNk2","text":"ProgressBar_text__1eW0j"};